<template>
  <div>
    <div v-if="keyPair.SshAuthorizedKey">
      <key-with-tool title="SSH Authorized Key" :text="keyPair.SshAuthorizedKey" :downloadFileName="`${name}_ssh.pub`" />
      <el-divider />
    </div>
    <div v-if="keyPair.PublicKey">
      <key-with-tool title="公钥" :text="keyPair.PublicKey" :downloadFileName="`${name}.pub`" />
      <el-divider />
    </div>
    <div v-if="keyPair.Passphrase">
      <key-with-tool title="私钥密码" :text="keyPair.Passphrase" :password="true" />
      <el-divider />
    </div>
    <key-with-tool title="私钥" :text="keyPair.PrivateKey" :downloadFileName="`${name}.key`" />
  </div>
</template>

<script>
import KeyWithTool from './keyWithTool.vue'

export default {
  name: "keyDetails",
  props: [ "name" ,"keyPair"],
  components: { KeyWithTool },
  methods: {
  },
}
</script>
